import { api } from "../middleware/api";
import { END_POINTS } from "../utils/constants/endPoints";

export const rentChaserService = {
  signup,
  getLoginLink,
};

function signup(agencyName?: string) {
  return api.post(END_POINTS.signupRentChaser, {
    agency_name: agencyName,
    agencyName: agencyName,
  });
}

function getLoginLink() {
  return api.get(END_POINTS.rentChaserLoginLink, null);
}
